module.exports = __webpack_public_path__ + "static/media/01-3-x-copy-2@2x.8d387f51.png";